import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { BreadcrumbService } from './breadcrumb.service';
import { Component } from '@angular/core';

@Component({
  selector: 'sha-breadcrumb',
  templateUrl: 'breadcrumb.component.html',
  styleUrls: ['breadcrumb.component.css'],
})
export class BreadcrumbComponent {
  segments: ActivatedRoute[];

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbLabels: BreadcrumbService) {
    this.segments = new Array();
    this.router.events
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.routeChanged(event);
        }
      });
  }

  public routeChanged(event: any) {
    this.segments.length = 0;
    this.generateBreadcrumbTrail(this.router.routerState.root);
  }

  public generateBreadcrumbTrail(route: ActivatedRoute): void {
    route.children.forEach(childRoute => {
      if (childRoute.outlet === 'primary') {
        if (childRoute.snapshot.url.length > 0 && childRoute.snapshot.data && childRoute.snapshot.data.title) {
          this.segments.push(childRoute);
        }
        this.generateBreadcrumbTrail(childRoute);
      }
    });
  }

  public navigateTo(route: ActivatedRoute): void {
    this.router.navigateByUrl(this.breadcrumbLabels.buildUrl(route));
  }

  public routeName(route: ActivatedRoute): string {
    return this.breadcrumbLabels.getLabel(route);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/breadcrumb/breadcrumb.component.ts